module.exports = __webpack_public_path__ + "media/images/Heart_White_2x-1c022cff.png";